import { CreateGroupeForm } from "./components/create-groupe-form";
import { EditGroupeForm } from "./components/edit-groupe-form";

interface GroupeFormProps {
  groupeId?: number;
  onCancel: () => void;
  onSuccess: () => void;
}

export function GroupeForm({ groupeId, onCancel, onSuccess }: GroupeFormProps) {
  if (groupeId) {
    return (
      <EditGroupeForm
        groupeId={groupeId}
        onCancel={onCancel}
        onSuccess={onSuccess}
      />
    );
  }

  return (
    <CreateGroupeForm
      onCancel={onCancel}
      onSuccess={onSuccess}
    />
  );
}

